angular.module('bmsApp.trugreen.inventory').controller('TGInventorySaveCtrl',
	function ($state,
			  $scope,
			  $q,
	          TGProductSvc,
			  TGInventorySvc) {

	let self = this;

	angular.extend(self, {
		formValidatorConfig: {},
		options: {},
		processing: false,
	});

		this.$onInit = () => {
			self.updating = $state.is('main.trugreen.inventory.index.edit');
			let promises = {
				products: TGProductSvc.productList.index(),
			};
			if (self.updating) {
				angular.extend(promises, {
					product: TGInventorySvc.read({id: $state.params.inventoryId}),
				});
			}

			$q.all(promises).then((responses) => {
				self.options.products = responses.products.data.tg_products_list;
				if (self.updating) {
					self.product = responses.product.data.product;
				}
			});

		};

		self.formValidatorConfig.submitHandler = function() {
			self.processing = true;
			TGInventorySvc.save(self.product).then(function(response){
				self.processing = false;
				$state.go('main.trugreen.inventory.index');
			}, function(errors) {
				self.errors = errors;
				self.processing = false;
			});
		};

		self.formValidatorConfig.errorPlacement = function(error) {
			self.errorMessage = error;
			self.processing = false;
			$scope.$apply();
		};
	});